module.exports = __webpack_public_path__ + "img/hohlsaum_hellgrau_farbnummer705.6d6c5549.jpg";